import React from "react"
import PropTypes from "prop-types"

const TrucksPanel = ({ trucks, onChange, onAdd, onRemove }) => (
  <div className="av-panel">
    <div className="av-panel-title">Logística de Camiones</div>

    {trucks.length > 0 && (
      <div className="mb-2">
        <div className="av-truck-grid">
          <div className="av-truck-head">Núm Camiones</div>
          <div className="av-truck-head">Unidades/Camión</div>
          <div />
        </div>

        {trucks.map(truck => (
          <div className="av-truck-grid" key={truck.key}>
            <input
              type="number"
              min={truck.ids.length || 0}
              step="1"
              placeholder="0"
              className="av-truck-input av-num"
              value={truck.count}
              onChange={event => onChange(truck.key, "count", event.target.value)}
              title={
                truck.ids.length
                  ? `${truck.ids.length} camión(es) ya registrado(s): solo puedes aumentar`
                  : undefined
              }
            />
            <input
              type="number"
              min="0"
              placeholder="0"
              className="av-truck-input av-num"
              value={truck.units}
              onChange={event => onChange(truck.key, "units", event.target.value)}
            />
            {truck.ids.length > 0 ? (
              // los camiones ya guardados no se pueden eliminar: el backend no
              // borra filas de daily_availability_quantities
              <span />
            ) : (
              <button
                type="button"
                className="av-btn-icon"
                title="Quitar renglón"
                onClick={() => onRemove(truck.key)}
              >
                <i className="bx bx-x" />
              </button>
            )}
          </div>
        ))}
      </div>
    )}

    <button type="button" className="av-btn-dashed" onClick={onAdd}>
      <i className="bx bx-plus" />
      Agregar camión
    </button>
  </div>
)

TrucksPanel.propTypes = {
  trucks: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
}

export default TrucksPanel
